import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mSource from 'models/source';
// Custom
import { deleteInstallationSource } from 'actions';
import { showDeleteMenuItems } from 'utils/MenuItems';
import { sourcesShape } from 'constants/PropTypesShapes';
import { configurationSourcesAddPath, configurationSourcesShowPath } from 'installations/navigation';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import { AddTextButton } from 'components/buttons/TextButtons';
import withEntitiesInformation from 'installations/assets/hocs/WithEntitiesInformation';
import SourceItem from 'installations/assets/configuration/SourceItem';

class Sources extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { deleted, onUpdate } = this.props;
    const { deleted: prevDeleted } = prevProps;
    if (!prevDeleted && deleted) {
      onUpdate();
    }
  }

  // Handlers
  handleDelete(source) {
    const { id, handleDisplayConfirm, handleDeleteSource } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteSource', values: { sourceName: source.name } },
      () => handleDeleteSource(id, source.id),
    );
  }

  render() {
    const { id, sources } = this.props;
    const sortedSources = mSource.sortElements(sources.elements);

    // Permissions
    const { pInstallation: { configWrite } } = permissions;

    return (
      <CollapseBoxTemplate
        title={<LocalizedMessage id="title.sources" />}
        buttons={[
          <OnlyWith
            key="bAdd"
            permissions={{
              needed: configWrite,
              permissionsOrContext: 'installationPermissions',
            }}
          >
            <AddTextButton primary path={configurationSourcesAddPath(id)} />
          </OnlyWith>,
        ]}
      >
        <div className="p-3">
          <LoadingDisplayer loading={sources.loading}>
            <div className="row information-item-wrapper">
              {_isEmpty(sortedSources) && (
                <div className="col-12 mt-3">
                  <em>
                    <LocalizedMessage id="info.listNoElement" />
                  </em>
                </div>
              )}
              {!!sortedSources
                && _map(sortedSources, (source) => (
                  <div key={_toString(source.id)} className="col-lg-6 col-md-12">
                    <SourceItem
                      source={source}
                      menuItems={showDeleteMenuItems(
                        { path: configurationSourcesShowPath(id, source.id) },
                        { cb: this.handleDelete },
                      )}
                      permissions={{
                        needed: configWrite,
                        permissionsOrContext: 'installationPermissions',
                      }}
                    />
                  </div>
                ))}
            </div>
          </LoadingDisplayer>
        </div>
      </CollapseBoxTemplate>
    );
  }
}

Sources.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  deleted: PropTypes.bool.isRequired,
  sources: sourcesShape.isRequired,
  onUpdate: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleDeleteSource: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  sources: state.installationSource.list,
  deleted: state.installationSource.delete.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleDeleteSource: (id, idSource) => {
    dispatch(deleteInstallationSource(id, idSource));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirmDialog,
  withEntitiesInformation,
)(Sources);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/index/components/InstallationConfigurationSources.js